document.addEventListener('DOMContentLoaded', () => {
  const navbars = document.querySelectorAll('.menu-tab-nav-wrapper');
  const rootStyle = document.documentElement.style;
  let isScrollingToTarget = false;

  function updateFixedNavHeight() {
    const wrappers = document.querySelectorAll('.menu-tab-nav-wrapper');
    let applied = false;

    wrappers.forEach((wrapper) => {
      const rect = wrapper.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;

      if (inView && !applied) {
        const height = wrapper.offsetHeight;
        rootStyle.setProperty('--fixed-nav-height', `${height}px`);
        applied = true;
      }
    });

    if (!applied) {
      rootStyle.removeProperty('--fixed-nav-height');
    }
  }

  window.addEventListener('scroll', updateFixedNavHeight, { passive: true });
  window.addEventListener('resize', updateFixedNavHeight);
  //updateFixedNavHeight();

  navbars.forEach((container) => {
    const navList = container.querySelector('ul');
    const prevButton = container.querySelector('.menu-tab-nav-controls-prev');
    const nextButton = container.querySelector('.menu-tab-nav-controls-next');
    const navControls = container.querySelector('.menu-tab-nav-controls');
    const highlightCurrent = container.dataset.highlightCurrent === '1';
    const gradientOffset = 12;

    if (!navList) return;

    function checkScrollbar() {
      if (navList.scrollWidth > navList.clientWidth) {
        navControls?.classList.remove('hidden');
      } else {
        navControls?.classList.add('hidden');
      }
    }

    function scrollNavigation(direction) {
      const children = Array.from(navList.children);
      const scrollLeft = navList.scrollLeft;
      let scrollPosition = null;

      if(highlightCurrent){
        const activeIndex = children.findIndex((el) =>
          el.querySelector('a')?.classList.contains('is-active')
        );
        
        let targetIndex = null;
        
        if (direction === 'prev' && activeIndex > 0) {
          targetIndex = activeIndex - 1;
        } else if (direction === 'next' && activeIndex < children.length - 1 && activeIndex !== -1) {
          targetIndex = activeIndex + 1;
        }

        if (targetIndex !== null && targetIndex >= 0 && targetIndex < children.length) {
          children[targetIndex]?.querySelector('a[href^="#"]')?.click();
        }
      }else{
        if (direction === 'prev') {
          for (let i = children.length - 1; i >= 0; i--) {
            const el = children[i];
            const elLeft = el.offsetLeft;
            const elRight = elLeft + el.offsetWidth;
            if (elRight <= scrollLeft + gradientOffset) {
              scrollPosition = elLeft;
              break;
            }
          }
          if (!scrollPosition) scrollPosition = gradientOffset;
        } else {
          for (let i = 0; i < children.length; i++) {
            const el = children[i];
            const elLeft = el.offsetLeft;
            if (elLeft >= scrollLeft + gradientOffset + 1) {
              scrollPosition = elLeft;
              break;
            }
          }
        }

        if (scrollPosition !== null) {
          navList.scrollTo({
            left: scrollPosition - gradientOffset,
            behavior: 'smooth',
          });
        }
      }
    }

    function handleScrollHighlight() {
      if (isScrollingToTarget) return;

      const navItems = Array.from(navList.children);
      if (navItems.length === 0) return;

      const sections = navItems.map((li) => {
        const link = li.querySelector('a[href^="#"]');
        if (!link) return null;
        const anchor = link.getAttribute('href')?.substring(1);
        if (!anchor) return null;
        return document.getElementById(anchor);
      });

      const scrollY = window.scrollY;
      const viewportMiddle = scrollY + window.innerHeight / 2;

      let activeIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        if (!section) continue;
        const style = window.getComputedStyle(section);
        const isVisible = style.display !== 'none' && style.visibility !== 'hidden' && section.offsetParent !== null && section.offsetWidth > 0 && section.offsetHeight > 0;
        if (!isVisible) continue;
        const rect = section.getBoundingClientRect();
        const sectionTop = scrollY + rect.top;
        if (viewportMiddle >= sectionTop) {
          activeIndex = i;
        }
      }

      navItems.forEach((li, i) => {
        const span = li.querySelector('a');
        if (span && highlightCurrent) {
          span.classList.toggle('is-active', i === activeIndex);
        }
      });

      const activeLi = navItems[activeIndex];
      if (activeLi) {
        const ulRect = navList.getBoundingClientRect();
        const liRect = activeLi.getBoundingClientRect();
        const ulScrollLeft = navList.scrollLeft;
        const liCenter = liRect.left + liRect.width / 2;
        const ulCenter = ulRect.left + ulRect.width / 2;
        const scrollTo = ulScrollLeft + (liCenter - ulCenter);
        navList.scrollTo({ left: scrollTo, behavior: 'smooth' });
      }
    }

    prevButton?.addEventListener('click', () => scrollNavigation('prev'));
    nextButton?.addEventListener('click', () => scrollNavigation('next'));

    checkScrollbar();
    handleScrollHighlight();
    window.addEventListener('resize', checkScrollbar);
    window.addEventListener('resize', handleScrollHighlight);
    document.body.addEventListener('tabChanged', checkScrollbar);
    document.body.addEventListener('tabChanged', handleScrollHighlight);
    
    let scrollRAF = null;
    window.addEventListener('scroll', () => {
      if (scrollRAF) return;
      scrollRAF = requestAnimationFrame(() => {
        handleScrollHighlight();
        scrollRAF = null;
      });
    }, { passive: true });
  });
});
